import React from "react";
import { StdToolbar, ContentBlock } from "../../components";
import { customerTypeService } from "../../api";
import { enums, alertError, confirm2, notifySuccess } from "../../base";
import AuthorizedComponent from "../authorized-component";
import CustomerTypeGrid from "./customer-type-grid";
import CustomerTypeForm from "./customer-type-form";
import { CustomerTypeModel } from "../../models";

export default class CustomerTypePage extends AuthorizedComponent {
    objectName = "CustomerType";
    gridRef = React.createRef<CustomerTypeGrid>();
    formRef = React.createRef<CustomerTypeForm>();
    toolbarRef = React.createRef<StdToolbar>();

    constructor(props: any) {
        super(props);

        this.onModelSelected = this.onModelSelected.bind(this);
        this.onButtonClick = this.onButtonClick.bind(this);
        this.onSaved = this.onSaved.bind(this);
    }

    onModelSelected(model: CustomerTypeModel) {
        this.toolbarRef.current?.setModel(model);
    }

    onButtonClick(model: CustomerTypeModel, name: string) {
        switch (name) {
            case "add":
                if (this.permissions[enums.stdActions.create]) {
                    this.formRef.current?.show({});
                }
                break;

            case "edit":
                if (this.permissions[enums.stdActions.update]) {
                    this.formRef.current?.show(model);
                }
                break;

            case "delete":
                if (this.permissions[enums.stdActions.delete]) {
                    this.delete(model.id!);
                }
                break;
        }
    }

    async delete(id: number) {
        if (!await confirm2("确定要删除该客户类型吗？")) {
            return;
        }
        
        const res = await customerTypeService.delete(id);

        if (res.succeeded) {
            notifySuccess("已成功删除数据");
            this.gridRef.current?.refresh();
        } else {
            alertError(res.message!);
        }
    }

    onSaved() {
        this.gridRef.current?.refresh();
    }

    render() {
        return (
            <ContentBlock caption={"客户类型"}>
                <StdToolbar 
                    permissions={this.permissions} 
                    ref={this.toolbarRef} 
                    onButtonClick={this.onButtonClick} />
                <CustomerTypeGrid
                    ref={this.gridRef}
                    onModelSelected={this.onModelSelected}
                    onButtonClick={this.onButtonClick} />
                <CustomerTypeForm ref={this.formRef} onSaved={this.onSaved} />
            </ContentBlock>
        );
    }
}